import React from "react";

export default function InfoIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={17}
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M8 15.918a7 7 0 1 1 0-14 7 7 0 0 1 0 14Zm0 1a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
      />
      <path
        fill="currentColor"
        d="m8.93 7.506-2.29.287-.082.381.45.082c.294.07.352.176.288.47l-.738 3.468c-.194.896.105 1.318.808 1.318.545 0 1.178-.252 1.465-.597l.088-.416c-.2.175-.492.246-.686.246-.275 0-.375-.194-.304-.534L8.93 7.506ZM9 5.418a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
      />
    </svg>
  );
}
